import React from 'react';
import { omit } from '../../utils';
import { Spinner } from '../spinner/Spinner';
import { BootstrapButton } from '../bootstrap-button/BootstrapButton';

export interface IndeterminateButton extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  color: 'primary' | 'default' | 'secondary' | 'success' | 'info' | 'danger' | 'warning' | 'link';
  size?: 'lg' | 'sm';
  block?: boolean;
  children: string | React.ReactNode;
  isLoading?: boolean;
};

const omitKeys = ['loadingContent', 'defaultContent', 'isLoading'];
const darkButtons = ['danger', 'info', 'success'];

/**
 * The `IndeterminateButton` works similar to reactstrap's Button component. Use it to inform users about the status of ongoing processes, such submitting a form, or saving updates.
 * 
 * Pass the `isLoading` prop to disable the button (to prevent additional clicks) and render a `Spinner` inside the button.
 */
export const IndeterminateButton = (props: IndeterminateButton) => {
  const { isLoading, color, children } = props; 
  const iconColor = darkButtons.indexOf(color) > -1 ? 'white' : '#898989';
  const buttonIcon = isLoading
    ? <Spinner size="xs" color={iconColor} className="mr-2"/>
    : undefined
  ;
  return (
    <BootstrapButton
    disabled={isLoading}
    {...omit(props, omitKeys)}
    >
      {buttonIcon}
      <span className="mx-auto">{children}</span>
    </BootstrapButton>
  )
}
IndeterminateButton.defaultProps = {
  color: 'primary',
  size: '',
  block: false,
  isLoading: false,
}
  
export default IndeterminateButton;
